<nz-skeleton
  *ngFor="let skeleton of skeletonList"
  [nzActive]="true"
  [nzLoading]="isLoading"
></nz-skeleton>
